import React, { useRef } from 'react'
import Dropdown from '../../Common/DropDown'
import { useState } from 'react'
import { Divider } from 'antd'
import { useNavigate } from 'react-router-dom'
import DeleteMenuPopUp from '../ScriptInfo/DeleteMenu'
import { handleFileInput, parseToBody, saveContent, updateStatus } from './utils/scriptUtils'
import { toast } from 'react-toastify'
import { autoFormatScript } from './utils/formatUtils'
import { useDispatch, useSelector } from 'react-redux'
import SaveAsModal from '../modals/SaveAsModal'
import html2pdf from 'html2pdf.js'
import { PADDING, PAGE_HEIGHT } from './utils/pageUtils'
import { exportContentStyle, expandSplitParagraph } from './utils/exportUtils'
import { hasTitlePageContent, buildTitlePageHtml } from './utils/titlePageUtils'
import CharactersModal from './CharactersModal'
import { setIsTranslateOpen } from '../../../store/navSlice'

const DesktopMenuBar = ({ setShowScriptLoading, scriptData, editor, documentType, onImported }) => {
  const [isDeleteMenuOpen, setIsDeleteMenuOpen] = useState(false)
  const scenes = useSelector(state => state.script.scenes.allScenes)
  const [isSaveAsModalOpen, setIsSaveAsModalOpen] = useState(false)
  const [isCharacterModalOpen, setIsCharacterModalOpen] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const pdfInputRef = useRef(null)
  const fdxInputRef = useRef(null)
  const [isLoading, setisLoading] = useState(null)
  const user = JSON.parse(localStorage.getItem('user'))

  const { title, author, copyright, byline, type, basedOn, email, phoneNumber } = scriptData || {}

  const handleDeleteClcik = () => {
    setIsDeleteMenuOpen(true)
  }

  const exportToPdf = async () => {
    if (scriptData.userId !== user._id) {
      toast.error("Only Admin is allowed to download the script")
      return
    }

    if (editor) {
      setShowScriptLoading(true)
      const body = editor.getBody()

      const wrapper = document.createElement('pdfupload');



      wrapper.className = 'pdf-container'
      wrapper.style.display = 'block'
      wrapper.style.paddingTop = `${PADDING}px`
      wrapper.style.paddingBottom = `${20}px`
      wrapper.style.width = `${794.993}px`

      // The saved Title Page goes first, unnumbered, and only when it has real content.
      // The divider after it carries no page number, so screenplay numbering starts after it.
      if (type !== 'TREATMENT' && hasTitlePageContent(scriptData)) {
        const titleDiv = document.createElement('div')
        titleDiv.innerHTML = buildTitlePageHtml(scriptData, PAGE_HEIGHT)
        wrapper.appendChild(titleDiv)
        const pageBreak = parseToBody(`<div class="custom-pagebreak" data-no-continue data-page="" />`).firstChild
        wrapper.appendChild(pageBreak)
      }

      body.childNodes.forEach(node => {
        const nodeClass = node.classList[0]
        const cloneNode = node.cloneNode(true)
        if (nodeClass === "custom-pagebreak") {
          cloneNode.style.height = `5px`
        }
        expandSplitParagraph(cloneNode, 5).forEach(n => wrapper.appendChild(n))
      })

      const styles = document.createElement('style');
      styles.innerHTML = exportContentStyle;
      wrapper.prepend(styles);

      const timestamp = Math.floor(Date.now() / 1000);
      const fileName = `${scriptData.title || 'Script'} - ${timestamp}.pdf`;

      html2pdf()
        .set({
          filename: fileName,
          format: 'letter',
          autoPaging: true,
          pagebreak: {
            mode: ['avoid-all', 'css', 'legacy'],
            before: '.page-break-before',
            after: '.page-break-after',
            avoid: '.page-break-avoid'
          },
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        })
        .from(wrapper)
        .save().then(() => { setShowScriptLoading(false) });
    }
  };

  const handleInput = async (e) => {
    setisLoading(true)
    setShowScriptLoading(true)
    const body = await handleFileInput(e)
    setisLoading(false)
    setShowScriptLoading(false)
    pdfInputRef.current.value = null
    fdxInputRef.current.value = null
    if (!body) {
      return
    }

    const formattedContent = autoFormatScript(body.text, documentType)

    if (editor) {
      editor.setContent(formattedContent.toString())
      onImported?.()
    }
    else {
      toast.error('editor not loaded')
    }


  }

  const handleSaveClick = () => {
    setShowScriptLoading(true)
    const onComplete = () => {
      toast.success('Saved')
      setShowScriptLoading(false)
    }
    if (editor) {
      saveContent(editor, scriptData, onComplete, scenes?.length)
    }
  }

  const handleMarkScript = async (status) => {
    setShowScriptLoading(true)
    const onComplete = () => {
      return toast.success('Saved')
    }
    await updateStatus(scriptData, status, onComplete)
    setShowScriptLoading(false)
  }

  return (
    <>
      {isSaveAsModalOpen && <SaveAsModal scripData={scriptData} isSaveAsModalOpen={isSaveAsModalOpen} setIsSaveAsModalOpen={setIsSaveAsModalOpen} />}
      {isDeleteMenuOpen && <DeleteMenuPopUp onDelete={() => { navigate(`/home`) }} isOpen={isDeleteMenuOpen} setIsOpen={setIsDeleteMenuOpen} id={scriptData._id} />}
      <input onChange={handleInput} ref={pdfInputRef} type="file" accept="application/pdf" className="hidden" />
      <input onChange={handleInput} ref={fdxInputRef} type="file" accept=".fdx" className="hidden" />
      <div className={`flex items-center gap-2 ${isLoading && 'cursor-progress'}`}>
        <Dropdown
          alignment='left'
          triggerAction='hover'
          showArrow={true}
          trigger={<button className='ms-1 text-[14px] font-bold text-[#868686] hover:text-[#292929]'>File</button>}>
          <div className='w-fit min-w-[150px] flex flex-col'>

            <button onClick={() => { pdfInputRef.current.click() }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Open</button>
            <button onClick={() => { pdfInputRef.current.click() }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Import Script</button>
            <button onClick={() => { pdfInputRef.current.click() }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Upload PDF</button>
            <button onClick={() => { fdxInputRef.current.click() }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Upload FDX</button>
            <button className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Auto Format</button>
            <button onClick={() => { exportToPdf() }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Export</button>
            <button onClick={handleSaveClick} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Save</button>
            <button onClick={() => { setIsSaveAsModalOpen(true) }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Save a Copy</button>
            <button onClick={() => { handleMarkScript('INCOMPLETE') }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Mark Script in Progress</button>
            <button onClick={() => { handleMarkScript('INREVIEW') }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Mark Script In Review</button>
            <button onClick={() => { handleMarkScript('COMPLETE') }} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Mark Script Complete</button>
            <button onClick={handleDeleteClcik} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Delete</button>
          </div>
        </Dropdown>
        <Divider type='vertical' className='bg-gray-300 w-[1px] h-4' />

        <Dropdown
          alignment='left'
          triggerAction='hover'
          showArrow={true}
          trigger={<button className='ms-1 text-[14px] font-bold text-[#868686] hover:text-[#292929]'>Document</button>}>
          <div className='w-fit min-w-[150px] flex flex-col'>
            <button onClick={() => setIsCharacterModalOpen(true)} className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Characters</button>
            <button className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Headings</button>
          </div>
        </Dropdown>
        <Divider type='vertical' className='bg-gray-300 w-[1px] h-4' />
        <Dropdown
          alignment='left'
          triggerAction='hover'

          showArrow={true}
          trigger={<button className='ms-1 text-[14px] font-bold text-[#868686] hover:text-[#292929]'>Help</button>}>
          <div className='w-fit min-w-[150px] flex flex-col'>
            <button className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>Get in touch</button>
            <button className='px-6 p-2 text-[13px] text-[#868686] font-semibold text-start hover:bg-[#FFF5E6] hover:text-[#FFA300] transition-colors duration-200'>FAQ</button>
          </div>
        </Dropdown>
        <Divider type='vertical' className='bg-gray-300 w-[1px] h-4' />
        <button onClick={() => {
          dispatch(setIsTranslateOpen(true))
        }} className='ms-1 text-[14px] font-bold text-[#868686] hover:text-[#292929]'>Select Language</button>

        <CharactersModal open={isCharacterModalOpen} setOpen={setIsCharacterModalOpen} />
      </div>
    </>
  )
}

export default DesktopMenuBar